import Vue from 'vue'
import Router from 'vue-router'

// Llama el concept desde la configuración de ruta del módulo
import {router as usuariosRouter} from '@/modules/usuarios/usuariosRouter.js'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')
const PedidosIndex = () => import('@/views/Pedidos/PedidosIndex')
const PedidosDetail = () => import('@/views/Pedidos/PedidosDetail')
const VendedoresIndex = () => import('@/views/Vendedores/VendedoresIndex')
const VendedoresDetail = () => import('@/views/Vendedores/VendedoresDetail')

const BannersIndex = () => import('@/views/Banners/BannersIndex')
const BannersDetail = () => import('@/views/Banners/BannersDetail')

const CategoriasIndex = () => import('@/views/Categorias/CategoriasIndex')
const CategoriasDetail = () => import('@/views/Categorias/CategoriasDetail')

const FaqsIndex = () => import('@/views/Faqs/FaqsIndex')
const FaqsDetail = () => import('@/views/Faqs/FaqsDetail')

// HELPER PAGES
const Page404 = () => import('@/views/utils/Page404')
const Login = () => import('@/views/auth/Login')

Vue.use(Router)

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/pedidos',
      name: 'Inicio',
      component: DefaultContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        }
      ]
    },
    usuariosRouter,
    {
      path: '/categorias',
      redirect: '/categorias/list',
      name: 'Categorias',
      component: DefaultContainer,
      children: [
        {
          path: 'list',
          name: 'Lista',
          component: CategoriasIndex
        },
        {
          path: 'detail/:id',
          name: 'Detalle de categoria',
          component: CategoriasDetail
        },
        {
          path: 'new',
          name: 'Nueva categoria',
          component: CategoriasDetail
        }
      ]
    },
    {
      path: '/faqs',
      redirect: '/faqs/list',
      name: 'Preguntas frecuentes',
      component: DefaultContainer,
      children: [
        {
          path: 'list',
          name: 'Lista',
          component: FaqsIndex
        },
        {
          path: 'detail/:id',
          name: 'Detalle de pregunta',
          component: FaqsDetail
        },
        {
          path: 'new',
          name: 'Nueva pregunta',
          component: FaqsDetail
        }
      ]
    },
    {
      path: '/banners',
      redirect: '/banners/list',
      name: 'Banners',
      component: DefaultContainer,
      children: [
        {
          path: 'list',
          name: 'Lista',
          component: BannersIndex
        },
        {
          path: 'detail/:id',
          name: 'Detalle de banner',
          component: BannersDetail
        },
        {
          path: 'new',
          name: 'Nuevo banner',
          component: BannersDetail
        }
      ]
    },

    {
      path: '/pedidos',
      redirect: '/pedidos/list',
      name: 'Pedidos',
      component: DefaultContainer,
      children: [
        {
          path: 'list',
          name: 'Lista',
          component: PedidosIndex
        },
        {
          path: 'detail/:id',
          name: 'Detalle de pedido',
          component: PedidosDetail
        }
      ]
    },
    {
      path: '/vendedores',
      redirect: '/vendedores/list',
      name: 'Vendedores',
      component: DefaultContainer,
      children: [
        {
          path: 'list',
          name: 'Lista',
          component: VendedoresIndex
        },
        {
          path: 'detail/:id',
          name: 'Detalle de vendedor',
          component: VendedoresDetail
        },
        {
          path: 'new',
          name: 'Nuevo vendedor',
          component: VendedoresDetail
        }
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        }
      ]
    },
    {
      path: '/auth',
      redirect: '/auth/login',
      name: 'Auth',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
      ]
    },
    {
      path: '*',
      redirect: '/pages/404',
      name: 'Bootstrap'
    }
  ]
})
